export const listCircadianWidgets = async (sendAndWaitWs) => {
  const request = {};
  const response = await sendAndWaitWs(
    "/widget/circadian/list",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const saveCircadianWidget = async (sendAndWaitWs, widgetData) => {
  const request = {
    item: widgetData,
  };
  const response = await sendAndWaitWs(
    "/widget/circadian/save",
    JSON.stringify(request)
  );
  console.log(response);
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const deleteCircadianWidget = async (sendAndWaitWs, widgetId) => {
  const request = {
    widgetId,
  };
  const response = await sendAndWaitWs(
    "/widget/circadian/delete",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const updateCircadianConfig = async (
  sendAndWaitWs,
  widgetId,
  curve,
  offset,
  multiplier
) => {
  const request = {
    widgetId,
    curve,
    offset,
    multiplier,
  };
  const response = await sendAndWaitWs(
    "/widget/circadian/updateConfig",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const createWidgets = async (sendAndWaitWs, items) => {
  const request = { items };
  const response = await sendAndWaitWs(
    "/widget/create",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const updateWidgetData = async (sendAndWaitWs, items) => {
  const response = await sendAndWaitWs(
    "/widget/data/update",
    JSON.stringify({
      items,
    })
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const updateWidgetSetting = async (sendAndWaitWs, item) => {
  const response = await sendAndWaitWs(
    "/widget/setting/update",
    JSON.stringify({
      item,
    })
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const triggerWidgetEvent = async (sendAndWaitWs, widgetId, value) => {
  const response = await sendAndWaitWs(
    "/widget/button/trigger",
    JSON.stringify({
      widgetId,
      value,
    })
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const getDefaultWidgets = async (sendAndWaitWs) => {
  const response = await sendAndWaitWs(
    "/widget/default/get",
    JSON.stringify({})
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};
